import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import { DeliveryCondition } from '../../../../../interfaces/BackendModels';
import { StyledDeliveryConditionDetails } from './style';

interface DeliveryConditionDetailsProps {
  condition?: DeliveryCondition;
}

const formatPeriod = (start?: string | null, end?: string | null): string => {
  if (!start && !end) return '';
  if (start && end) {
    const from = dayjs(start).format('DD.MM.YYYY');
    const to = dayjs(end).format('DD.MM.YYYY');
    return from === to ? from : `${from} - ${to}`;
  }
  return dayjs(start ?? end).format('DD.MM.YYYY');
};

export const DeliveryConditionDetails = ({ condition }: DeliveryConditionDetailsProps) => {
  const intl = useIntl();

  const products = condition?.delivery_products ?? [];
  const period = formatPeriod(condition?.delivery_start_date, condition?.delivery_end_date);

  if (!condition || (!period && products.length === 0)) return null;

  return (
    <StyledDeliveryConditionDetails>
      {period && (
        <div className="delivery-period">
          <span className="delivery-period-label">
            {intl.formatMessage({ id: 'orders.delivery_period' })}
          </span>
          <span className="delivery-period-value">{period}</span>
        </div>
      )}
      {products.length > 0 && (
        <div className="delivery-products">
          <div className="delivery-products-title">
            {intl.formatMessage({ id: 'orders.delivery_products' })}
          </div>
          <ul className="delivery-products-list">
            {products.map((product) => (
              <li key={product.id} className="delivery-product-row">
                <span className="delivery-product-name">
                  {product.order_item?.product_name || '-'}
                </span>
                <span className="delivery-product-quantity">
                  {Number(product.delivery_quantity)} {product.order_item?.stock_unit ?? ''}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </StyledDeliveryConditionDetails>
  );
};
